import { RouteObject } from 'react-router-dom';
import { lazy, Suspense } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const WebDesignElPasoPage = lazy(() => import('../pages/web-design-el-paso/page'));
const SEOElPasoPage = lazy(() => import('../pages/seo-el-paso/page'));
const TurnkeyWebsitesPage = lazy(() => import('../pages/turnkey-websites/page'));
const SocialMediaMarketingElPasoPage = lazy(() => import('../pages/social-media-marketing-el-paso/page'));
const LocalSEOPage = lazy(() => import('../pages/local-search-engine-optimization/page'));
const PrivacyPolicyPage = lazy(() => import('../pages/privacy-policy/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const ElPasoSEOExpertsPage = lazy(() => import('../pages/el-paso-seo-experts/page'));
import GetSmallBusinessWebsitePage from '../pages/seo-el-paso/get-small-business-website/page';
import WhatDoesSEOCompanyDoPage from '../pages/blog/what-does-a-seo-company-do/page';
import LocalSEOElPasoPage from '../pages/blog/local-seo-el-paso/page';
import NotFound from "../pages/NotFound";

const BlogListingPage = lazy(() => import("../pages/blog/page"));
const LeadGenerationBlogPage = lazy(() => import("../pages/blog/local-business-website-lead-generation/page"));

const LazyWrapper = ({ children }: { children: React.ReactNode }) => (
  <Suspense fallback={<div>Loading...</div>}>
    {children}
  </Suspense>
);

const routes: RouteObject[] = [
  {
    path: '/',
    element: <LazyWrapper><HomePage /></LazyWrapper>,
  },
  {
    path: '/web-design-el-paso',
    element: <LazyWrapper><WebDesignElPasoPage /></LazyWrapper>,
  },
  {
    path: '/el-paso-seo',
    element: <LazyWrapper><SEOElPasoPage /></LazyWrapper>,
  },
  {
    path: '/el-paso-seo-experts',
    element: <LazyWrapper><ElPasoSEOExpertsPage /></LazyWrapper>,
  },
  {
    path: '/seo-el-paso/get-small-business-website',
    element: <GetSmallBusinessWebsitePage />
  },
  {
    path: '/blog/what-does-a-seo-company-do',
    element: <WhatDoesSEOCompanyDoPage />
  },
  {
    path: '/blog/local-seo-el-paso',
    element: <LocalSEOElPasoPage />
  },
  {
    path: '/turnkey-websites',
    element: <LazyWrapper><TurnkeyWebsitesPage /></LazyWrapper>,
  },
  {
    path: '/social-media-marketing-el-paso',
    element: <LazyWrapper><SocialMediaMarketingElPasoPage /></LazyWrapper>,
  },
  {
    path: '/local-search-engine-optimization',
    element: <LazyWrapper><LocalSEOPage /></LazyWrapper>,
  },
  {
    path: '/privacy-policy',
    element: <LazyWrapper><PrivacyPolicyPage /></LazyWrapper>,
  },
  {
    path: "/blog",
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <BlogListingPage />
      </Suspense>
    ),
  },
  {
    path: "/blog/local-business-website-lead-generation",
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <LeadGenerationBlogPage />
      </Suspense>
    ),
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
